'use client';

import { PropsWithChildren, createContext, useContext, ComponentType, forwardRef, AnchorHTMLAttributes } from 'react';

import { Tabs, TabList } from '../../Tabs';
import Tab from './Tab';

// Context for providing the Link component
export interface LinkComponentProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
	href: string;
}

export type LinkComponentType = ComponentType<LinkComponentProps>;

const LinkContext = createContext<LinkComponentType | undefined>(undefined);

export const useLinkComponent = () => useContext(LinkContext);

// Default fallback link component
const DefaultLink = forwardRef<HTMLAnchorElement, LinkComponentProps>(({ href, children, ...props }, ref) => (
	<a ref={ref} href={href} {...props}>
		{children}
	</a>
));
DefaultLink.displayName = 'DefaultLink';

export interface Props {
	activeTabIndex: number;
	LinkComponent?: LinkComponentType;
}

const TabsComponent = ({ activeTabIndex, LinkComponent, children }: PropsWithChildren<Props>) => {
	const linkToUse = LinkComponent || DefaultLink;

	return (
		<LinkContext.Provider value={linkToUse}>
			<Tabs value={activeTabIndex}>
				<TabList>{children}</TabList>
			</Tabs>
		</LinkContext.Provider>
	);
};

TabsComponent.Tab = Tab;

export default TabsComponent;
